import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { User } from '../_models';

@Injectable({
  providedIn: 'root',
})
export class MachinesService {
  updateMachineData = new BehaviorSubject<any>(null);

  constructor(private http: HttpClient) {}

  addMachine(machine: any) {
    return this.http.post(`${environment.apiUrl}/api/machines`, machine);
  }

  getAllMachines() {
    return this.http.get<User[]>(`${environment.apiUrl}/api/machines`).pipe(
      map((responseData) => {
        return responseData;
      })
    );
  }

  deleteMachine(machineId: number) {
    return this.http.delete(`${environment.apiUrl}/api/machines/${machineId}`);
  }

  updateMachine(machineId: number, machine: User) {
    return this.http.patch<User>(
      `${environment.apiUrl}/api/machines/${machineId}`,
      machine
    );
  }

  getAllOperations() {
    return this.http.get<any[]>(`${environment.apiUrl}/api/operations`);
  }
}
